import axios from "axios";

const apiPaymentGateway = axios.create({
  baseURL: process.env.REACT_APP_PAYMENT_GATEWAY_PUBLIC_URL,
});

export default apiPaymentGateway;